import { MaterialSymbols_300Light } from '@expo-google-fonts/material-symbols/300Light';

import type { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_300Light',
  font: MaterialSymbols_300Light,
};
export default weight;
